




































/**
 * 墓志铭管理
 * @author 祝超博
 */
import { Component, Ref, Vue } from 'vue-property-decorator'

import getSearchDefine from './search'
import getTableDefine from './table'
import getModalDefine from './modal'

import { PagerData } from '@/libs/request/request'
import service, { Epitaph } from '@/api/epitaph/Epitaph'

import IForm from '@/libs/formHelper/form/form.vue'
import IModalForm from '@/libs/formHelper/modalForm/modalForm.vue'
import IPagerTable from '@/libs/tableHelper/pagerTable.vue'

@Component({
  components: {
    IForm,
    IPagerTable,
    IModalForm
  }
})
export default class extends Vue {
  query: any = {
    page: 1,
    pageSize: 10,
    sorts: ['createTime']
  }

  // 表格数据
  tabledata: PagerData<Epitaph> = {
    total: 0,
    items: []
  }

  loading: boolean = true

  // 表格列定义
  get tableDefine () {
    return getTableDefine(this)
  }

  get searchDefine () {
    return getSearchDefine(this)
  }

  get modalDefine () {
    return getModalDefine(this)
  }

  @Ref('modal')
  modalRef?: IModalForm<Epitaph>

  created () {
    this.query.genealogyId = this.$route.query.id
    this.freshFromServer()
  }

  fetchDataFromServer (
    curPage: number | undefined = undefined,
    pageSize: number | undefined = undefined
  ) {
    if (curPage) {
      this.query.page = curPage
    }
    if (pageSize) {
      this.query.pageSize = pageSize
    }

    let loading = this.$Loading
    loading.start()
    this.loading = true
    this.queryHandle()
    service.getPagesOfEpitaph(this.query)
      .then((pagers) => {
        this.tabledata = pagers.result!
      })
      .catch((err) => {
        this.$Message.error(err.message)
      })
      .finally(() => {
        loading.finish()
        this.loading = false
      })
  }

  queryHandle () {
    Object.keys(this.query).forEach((v) => {
      if (!this.query[v] || this.query[v] < 0) delete this.query[v]
    })
  }

  //  刷新当前页
  freshFromServer (): void {
    this.fetchDataFromServer()
  }

  onSearch () {
    this.fetchDataFromServer(1)
  }

  // 点击创建新的数据
  onNewItem () {
    this.modalRef && this.modalRef.openForNew({})
  }

  // 插入数据
  onInsertItem (dataItem: Epitaph) {
    dataItem.genealogyId = this.query.genealogyId
    return service.addOneEpitaph(dataItem)
      .then(() => {
        this.$Message.success('新增成功')
        this.freshFromServer()
      })
  }

  onViewItem (dataItem: Epitaph) {
    this.modalRef && this.modalRef.openForView(dataItem)
  }

  // 点击编辑数据
  onEditItem (dataItem: Epitaph) {
    this.modalRef && this.modalRef.openForModi(dataItem)
  }

  // 更新数据
  onUpdateItem (dataItem: Epitaph) {
    return service.updateOneEpitaph(dataItem).then(() => {
      this.$Message.success('更新成功')
      this.freshFromServer()
    })
  }

  onDelItem (dataItem: Epitaph) {
    return service.deleteOneEpitaph(dataItem.id!)
      .then(() => {
        this.$Message.success('删除成功')
        this.freshFromServer()
      }).catch(error => {
        this.$Message.error(error.message)
      })
  }

  backToGenealogyMain () {
    let routerName = 'genealogyManageAll'
    if (this.$route.query.type === 'family') {
        routerName = 'familyManageAll'
    }
    this.$router.push({
      name: routerName
    })
  }
}
